import React, { useState, useEffect } from 'react';
import { toast } from '../../../../utils/toast';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Switch,
  FormControlLabel,
  Button,
} from '@mui/material';
import { ImpuestoDto } from '../../../../services/api/impuestosApi';
interface ImpuestoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: ImpuestoDto) => Promise<void>;
  title: string;
  initialData?: ImpuestoDto;
  isLoading: boolean;
  isEdit?: boolean;
}

const ImpuestoModal: React.FC<ImpuestoModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  initialData,
  isLoading,
  isEdit = false,
}) => {
  const [formData, setFormData] = useState<ImpuestoDto>({
    Nombre: '',
    Valor: 0,
    Activo: true,
  });

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData({
        Nombre: '',
        Valor: 0,
        Activo: true,
      });
    }
  }, [initialData, isOpen]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await onSubmit(formData);
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || 'Error al guardar los datos';
      toast.error('Error');
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nombre"
            fullWidth
            required
            value={formData.Nombre}
            onChange={(e) => setFormData({ ...formData, Nombre: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Valor"
            type="number"
            inputProps={{ step: "0.01", min: "0", max: "100" }}
            fullWidth
            required
            value={formData.Valor}
            onChange={(e) => setFormData({ ...formData, Valor: parseFloat(e.target.value) })}
            sx={{ mb: 2 }}
          />
          {!isEdit && (
            <FormControlLabel
              control={
                <Switch
                  checked={formData.Activo}
                  onChange={(e) => setFormData({ ...formData, Activo: e.target.checked })}
                />
              }
              label="Activo"
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={isLoading}>
            Cancelar
          </Button>
          <Button type="submit" variant="contained" disabled={isLoading}>
            {isLoading ? 'Guardando...' : isEdit ? 'Actualizar' : 'Guardar'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ImpuestoModal;
